<template>
  <div>
    <modal v-if="showModal" :title="title" @close="toggleModal(false)">
      <slot />
    </modal>
    <button @click="toggleModal(true)">
      <icon title="Close" icon="info-plain" :large="large" />
    </button>
  </div>
</template>

<script>
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'

export default {
  components: {
    Modal,
    Icon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
    }
  },
  methods: {
    toggleModal(open) {
      this.showModal = open
    },
  },
}
</script>
